var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIdtx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6923 23.5384C39.6923 31.9499 32.8731 38.7692 24.4615 38.7692C16.05 38.7692 9.23076 31.9499 9.23076 23.5384C9.23076 15.1268 16.05 8.30762 24.4615 8.30762C32.8731 8.30762 39.6923 15.1268 39.6923 23.5384Z",
    fill: "#DAF0F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4615 8.95381C16.4068 8.95381 9.87692 15.4837 9.87692 23.5384C9.87692 31.5931 16.4068 38.123 24.4615 38.123C32.5162 38.123 39.0461 31.5931 39.0461 23.5384C39.0461 15.4837 32.5162 8.95381 24.4615 8.95381ZM8.58461 23.5384C8.58461 14.77 15.6931 7.6615 24.4615 7.6615C33.2299 7.6615 40.3385 14.77 40.3385 23.5384C40.3385 32.3068 33.2299 39.4153 24.4615 39.4153C15.6931 39.4153 8.58461 32.3068 8.58461 23.5384Z",
    fill: "#08172D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4452 22.6436L26.8532 30.9432C26.7544 31.2593 26.4186 31.4349 26.1037 31.3361L25.6899 31.2077C25.375 31.1089 25.1994 30.7731 25.2982 30.4582L27.8902 22.1586C27.989 21.8436 28.3248 21.6669 28.6397 21.7657L29.0535 21.8941C29.3684 21.9929 29.544 22.3287 29.4452 22.6436Z",
    fill: "#08172D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2217 26.3655L32.2231 29.5612C32.1243 29.8761 31.7885 30.0517 31.4735 29.954L31.0598 29.8245C30.7449 29.7269 30.5693 29.3911 30.668 29.0761L31.6667 25.8794C31.7654 25.5644 32.1012 25.3877 32.4162 25.4865L32.8288 25.616C33.1438 25.7148 33.3194 26.0495 33.2217 26.3655Z",
    fill: "#08172D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0549 24.3914L35.0562 27.587C34.9575 27.902 34.6217 28.0776 34.3067 27.9799L33.8941 27.8504C33.5791 27.7527 33.4035 27.4169 33.5012 27.102L34.4998 23.9064C34.5986 23.5903 34.9344 23.4136 35.2494 23.5124L35.6631 23.6419C35.978 23.7406 36.1536 24.0764 36.0549 24.3914Z",
    fill: "#08172D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.468 20.9202L30.7901 26.2942C30.6913 26.6102 30.3555 26.7858 30.0406 26.6881L29.6268 26.5586C29.3119 26.4599 29.1363 26.1241 29.2351 25.8091L30.9141 20.4341C31.0117 20.1191 31.3476 19.9424 31.6625 20.0412L32.0762 20.1707C32.3912 20.2695 32.5668 20.6053 32.468 20.9202Z",
    fill: "#08172D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1586 28.3224L28.5191 33.5712C28.4203 33.8862 28.0845 34.0618 27.7695 33.9652L27.3558 33.8346C27.0409 33.7369 26.8653 33.4011 26.9641 33.0862L28.6036 27.8373C28.7023 27.5213 29.0381 27.3457 29.3531 27.4434L29.7668 27.5729C30.0818 27.6716 30.2573 28.0074 30.1586 28.3224Z",
    fill: "#08172D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4327 16.6635C20.4327 17.5359 19.7249 18.2438 18.8525 18.2438C17.9789 18.2438 17.2711 17.5359 17.2711 16.6635C17.2711 15.79 17.9789 15.0833 18.8525 15.0833C19.7249 15.0833 20.4327 15.79 20.4327 16.6635Z",
    fill: "#DC5545"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5949 20.8786C22.5949 21.7521 21.8871 22.4588 21.0147 22.4588C20.1412 22.4588 19.4333 21.7521 19.4333 20.8786C19.4333 20.0062 20.1412 19.2983 21.0147 19.2983C21.8871 19.2983 22.5949 20.0062 22.5949 20.8786Z",
    fill: "#0094C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9708 22.9704C18.9708 23.6036 18.4572 24.1172 17.824 24.1172C17.1897 24.1172 16.6762 23.6036 16.6762 22.9704C16.6762 22.3361 17.1897 21.8225 17.824 21.8225C18.4572 21.8225 18.9708 22.3361 18.9708 22.9704Z",
    fill: "#0094C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3583 15.9498C24.3583 16.583 23.8447 17.0976 23.2115 17.0976C22.5783 17.0976 22.0647 16.583 22.0647 15.9498C22.0647 15.3166 22.5783 14.803 23.2115 14.803C23.8447 14.803 24.3583 15.3166 24.3583 15.9498Z",
    fill: "#08172D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8968 25.3914C20.8968 26.0246 20.3832 26.5393 19.75 26.5393C19.1157 26.5393 18.6021 26.0246 18.6021 25.3914C18.6021 24.7582 19.1157 24.2446 19.75 24.2446C20.3832 24.2446 20.8968 24.7582 20.8968 25.3914Z",
    fill: "#08172D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9498 25.8565C17.9498 26.4897 17.4362 27.0033 16.803 27.0033C16.1698 27.0033 15.6562 26.4897 15.6562 25.8565C15.6562 25.2222 16.1698 24.7086 16.803 24.7086C17.4362 24.7086 17.9498 25.2222 17.9498 25.8565Z",
    fill: "#08172D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.88 12.8206C23.88 13.4538 23.3664 13.9685 22.7332 13.9685C22.1 13.9685 21.5854 13.4538 21.5854 12.8206C21.5854 12.1874 22.1 11.6738 22.7332 11.6738C23.3664 11.6738 23.88 12.1874 23.88 12.8206Z",
    fill: "#0094C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2669 20.676C16.2669 21.3092 15.7534 21.8227 15.1202 21.8227C14.487 21.8227 13.9734 21.3092 13.9734 20.676C13.9734 20.0428 14.487 19.5281 15.1202 19.5281C15.7534 19.5281 16.2669 20.0428 16.2669 20.676Z",
    fill: "#08172D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1112 29.7531C17.1112 30.3863 16.5976 30.8999 15.9633 30.8999C15.3301 30.8999 14.8165 30.3863 14.8165 29.7531C14.8165 29.1199 15.3301 28.6052 15.9633 28.6052C16.5976 28.6052 17.1112 29.1199 17.1112 29.7531Z",
    fill: "#0094C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdtx);
export default __webpack_public_path__ + "static/media/IDTX.6a244071efda5053add528e5092cd9d1.svg";
export { ForwardRef as ReactComponent };